import { IonIcon } from '@ionic/react';
import { caretBack } from 'ionicons/icons';

export const SubOutIcon: React.FC = () => (
  <IonIcon icon={caretBack} style={{ color: 'red' }} />
);
